import { render } from "./Payment_Confirmation.vue?vue&type=template&id=665337ca&scoped=true"
import script from "./Payment_Confirmation.vue?vue&type=script&lang=js"
export * from "./Payment_Confirmation.vue?vue&type=script&lang=js"

import "./Payment_Confirmation.vue?vue&type=style&index=0&id=665337ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665337ca"]])

export default __exports__